import apiParticipant from "@/api/participant";
import currencies from "@/helpers/constants/currencies";

const state = {
  contracts: [],
  currenciesComparisonTable: currencies
};

const actions = {
  async getContracts({ commit }, eventId) {
    const result = await apiParticipant.getContracts(eventId);
    if (result?.data) {
      commit("SET_VALUE", {
        name: "contracts",
        value: result.data
      });
    }
  }
};

const mutations = {
  SET_VALUE(state, { name, value }) {
    state[name] = value;
  },

  UPDATE_CONTRACT_EDO(state, { contractId, isEdo }) {
    const contract = state.contracts.find(c => c.id === contractId);
    if (contract) {
      contract.is_edo_rent = isEdo;
    }
  }
};

const getters = {
  acts(state) {
    return state.contracts.length
      ? state.contracts.reduce((acts, contract) => {
          acts = [
            ...acts,
            ...contract.documents
              .filter(document => document.type === "act")
              .map(document => {
                return {
                  ...document,
                  contract_number: contract.number
                };
              })
          ];
          return acts;
        }, [])
      : [];
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
